import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchParams: {
    contractNumber: undefined,
    clientNumber: undefined,
    labellerCode: undefined,
    startDate: null,
    endDate: null,
  },
  results: {
    isLoading: false,
    data: [],
    status: "idle",
    statusCode: 0,
    message: "",
    errors: [],
    searchWasMade: false,
    size: 10,
    page: 1,
    totalResults: 0,
    totalPages: 0,
  },
};

const materialRequestHistorySlice = createSlice({
  name: "materialRequestHistory",
  initialState,
  reducers: {
    setMaterialRequestHistorySearchParams: (state, action) => {
      state.searchParams = {
        ...state.searchParams,
        ...action.payload,
      };
    },

    setMaterialRequestHistoryPagination: (state, action) => {
      state.results.page = action.payload.page;
      state.results.size = action.payload.size;
    },

    setMaterialRequestHistoryLoading: (state, action) => {
      state.results = {
        ...state.results,
        isLoading: true,
        status: action.payload?.status || "loading",
        statusCode: 0,
        message: "Cargando...",
        errors: [],
        searchWasMade: true,
      };
    },

    setMaterialRequestHistoryResults: (state, action) => {
      state.results = {
        ...state.results,
        ...action.payload,
        isLoading: false,
        searchWasMade: true,
      };
    },

    resetMaterialRequestHistory: () => initialState,
  },
});

export const {
  setMaterialRequestHistorySearchParams,
  setMaterialRequestHistoryPagination,
  setMaterialRequestHistoryLoading,
  setMaterialRequestHistoryResults,
  resetMaterialRequestHistory,
} = materialRequestHistorySlice.actions;

export const selectMaterialRequestHistorySearchParams = (state) =>
  state.materialRequestHistory.searchParams;

export const selectMaterialRequestHistoryResults = (state) =>
  state.materialRequestHistory.results;

export default materialRequestHistorySlice.reducer;
